import { createSlice } from "@reduxjs/toolkit";
import { LoginSliceState } from "../types";

const initialState: LoginSliceState = {
  mobileNumber: "",
  userLogginedIn: false,
  token: "",
};

const LoginSlice = createSlice({
  name: "LoginSlice",
  initialState,
  reducers: {
    setmobileNumber(state, action) {
      state.mobileNumber = action.payload;
    },
    setIsUserLoggedIn(state, action) {
      state.userLogginedIn = action.payload;
    },
    setToken(state, action) { 
      state.token = action.payload;
    },
    logout: (state, action) => {
      const allLocalStorageKeys = Object.keys(localStorage); // Get all localStorage keys
      const allSessionStorageKeys = Object.keys(sessionStorage); // Get all sessionStorage keys

      allLocalStorageKeys.forEach((key) => {
        localStorage.removeItem(key); // Remove each item by its key
      });
      allSessionStorageKeys.forEach((key) => {
        sessionStorage.removeItem(key); // Remove each item by its key
      });
    },
  },
});

export const { setmobileNumber, setToken, setIsUserLoggedIn, logout } = LoginSlice.actions;
export default LoginSlice.reducer;
